import { render, staticRenderFns } from "./TurnOnPOS.vue?vue&type=template&id=da52e92c&lang=pug"
import script from "./TurnOnPOS.vue?vue&type=script&lang=js"
export * from "./TurnOnPOS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports